import getBrowserFingerprint from 'get-browser-fingerprint';

import api from '@/services/Api';

export default {
  signup({ hash, firstname, lastname, email, contactPhone, companyName, timezone, password, newsletter, recaptchaToken, source }) {
    if (hash) {
      return api().post('/auth/invitation/' + hash, { password, newsletter });
    }

    const data = {
      company_name: companyName,
      timezone,
      firstname,
      lastname,
      email,
      contact_phone: contactPhone,
      password,
      newsletter,
      recaptcha_token: recaptchaToken,
      source,
    };

    return api().post('/auth/signup', data);
  },

  login(email, password, code, trust) {
    const data = {
      email,
      password,
      browser: '' + getBrowserFingerprint({ enableScreen: false }),
    };
    if (code) {
      data.code = code;

      if (trust) {
        data.trust = 1;
      }
    }

    return api().post('/auth/login', data, { withCredentials: true });
  },

  logout() {
    return api().delete('/auth/logout');
  },

  forgottenPassword(email) {
    const data = { email };
    return api().post('/auth/forgotten-password', data);
  },

  resetPassword(token, { email, password, code, trust }) {
    const data = {
      email,
      password,
    };
    if (code) {
      data.code = code;
      // Here we intentionally do not send browser data without 2fa code.
      data.browser = '' + getBrowserFingerprint({ enableScreen: false });

      if (trust) {
        data.trust = 1;
      }
    }

    return api().post('/auth/reset-password/' + token, data);
  },

  updatePassword(entity) {
    const data = {
      current_password: entity.oldPassword,
      new_password: entity.newPassword,
    };
    return api().put('/user/' + entity.id + '/password', data);
  },

  refreshToken() {
    return api().post('/auth/refresh');
  },

  fetch() {
    return api().get('/auth/user');
  },

  enableGoogle2fa() {
    return api().post('/auth/2fa/google/enable');
  },

  confirmEnableGoogle2fa(secret, code) {
    return api().post('/auth/2fa/google/enable/confirm', { secret, code });
  },

  disableGoogle2fa(code) {
    return api().post('/auth/2fa/google/disable', { code });
  },

  invitationValidate(hash) {
    return api().get('/auth/invitation/' + hash + '/validate');
  },

  createInvitation({ firstname, lastname, email, level, visibleBrandIds }) {
    const data = {
      firstname,
      lastname,
      email,
      level,
      visible_brand_ids: visibleBrandIds,
    };
    return api().post('/user-invitation', data);
  },

  deleteInvitation(id) {
    return api().delete('/user-invitation/' + id);
  },

  resendInvitation(id) {
    return api().post('/user-invitation/' + id + '/resend');
  },

  fetchInvitations() {
    return api().get('/user-invitations');
  },

  verifyEmail(token) {
    return api().post('/auth/verify-email/' + token);
  },
};
